import React, {
  useMemo, useState, useEffect, useRef
} from "react";
import {
  productImagesSlider, smallVideo, imageItem, imageRound,
  swiperLoading, item, swiperSlides, swiperThumbnails, swiperDesktop,
  swiperDesktopNewLayout,
} from "./style.mod.scss";
import getFilePath from "helpers/get-file-path";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, Mousewheel } from "swiper";
import Image from "components/image";

const ProductImages = (props) => {
  const [swiper, setSwiper] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const swiperRef = useRef(null);
  const thumbsSwiperRef = useRef(null);

  const { currentVariant } = props;
  const variantImages = currentVariant?.variantImages || [];
  const videos = currentVariant?.videos || [];

  const images = useMemo(() => {
    const result = [...variantImages];
    videos.forEach((video) => {
      result.splice(video.position, 0, video);
    });
    return result;
  }, [variantImages, videos]);

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.update();
    }
    if (thumbsSwiperRef.current) {
      thumbsSwiperRef.current.update();
    }

    const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      const src = video.getAttribute("data-src");
      if (src) {
        video.src = src;
        video.load();
      }
    });
  }, [currentVariant]);

  const uniqueKey = `product-images-${currentVariant?._key || ""}`;

  const params = {
    slidesPerGroup: 1,
    slidesPerView: 1,
    direction: "horizontal",
    centeredSlides: true,
    modules: [Navigation, Thumbs, Mousewheel],
    speed: 600,
    parallax: true,
    preventClicks: true,
    preventClicksPropagation: false,
    simulateTouch: false,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    loop: true,
    navigation: { clickable: true },
    thumbs: { swiper: thumbsSwiper },
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      }
    }
  };

  let thumbnailsParams = {
    slidesPerView: props.slidesPerView ? props.slidesPerView : 5,
    slidesPerGroup: 1,
    spaceBetween: props.spaceBetween ? props.spaceBetween : 30,
    loop: true,
    direction: "vertical",
    freeMode: true,
    watchSlidesProgress: true,
    modules: [Navigation, Thumbs, Mousewheel],
    speed: 500,
    parallax: true,
    mousewheel: { enabled: true },
  };

  return (
    <div className={productImagesSlider} key={uniqueKey}>
      <div className={swiperSlides}>
        <Swiper
          className={`${swiper ? "" : swiperLoading}`}
          onSwiper={(swiper) => {
            setSwiper(swiper);
            swiperRef.current = swiper;
          }}
          {...params}>
          {images.map((image, i) => (
            <SwiperSlide key={i}>
              {(image._type === "limitedImage" || image._type === "image") ?
                <div className={`${imageItem} pointer ${item} item-${i}`} key={image._key}>
                  <Image image={image} alt={image.alt} />
                </div>
                : <div className={`${imageItem} pointer ${item} item-${i}`} key={image._key}>
                  <video
                    key={image.videoURL || image.video}
                    className={`${smallVideo}`}
                    type="video/mp4" autoPlay={true} muted={true}
                    playsInline={true} loop
                    data-src={image.videoURL ? image.videoURL : getFilePath(image.video)}
                  >
                    <source src={image.videoURL ? image.videoURL : getFilePath(image.video)} />
                    Sorry, your browser doesnt support embedded videos.
                  </video>
                </div>}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={`${swiperThumbnails} ${props.slidesPerView=== 4.5 ? swiperDesktopNewLayout : swiperDesktop}`} style={{ width: props.slidesPerView === 4 ? "17%" : "" }}>
        <Swiper
          onSwiper={(swiper) => {
            setThumbsSwiper(swiper);
            thumbsSwiperRef.current = swiper;
          }}
          {...thumbnailsParams}>
          {images.map((image, i) => (
            <SwiperSlide key={i}>
              {(image._type === "limitedImage" || image._type === "image") ?
                <div className={`${imageItem} pointer ${item} item-${i}`} key={image._key} >
                  <Image image={image} alt={image.alt} className={imageRound} />
                </div>
                : <div className={`${imageItem} pointer ${item} item-${i}`} key={image._key}>
                  <video
                    key={image.videoURL || image.video}
                    className={`${smallVideo} ${imageRound}`}
                    type="video/mp4"
                    autoPlay={true}
                    muted={true}
                    playsInline={true}
                    loop
                    data-src={image.videoURL ? image.videoURL : getFilePath(image.video)}
                  >
                    <source src={image.videoURL ? image.videoURL : getFilePath(image.video)} />
                    Sorry, your browser doesnt support embedded videos.
                  </video>
                </div>}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ProductImages;
